import React, { useEffect } from 'react';
import { Card, CardContent, CardHeader, Typography,IconButton, Grid, Box, WithStyles, withStyles } from '@material-ui/core';
import { Menu } from '@material-ui/icons';
import { ChatVentanaStyles } from '../../styles';
import { EnviarMensaje,Alerta,Mensaje } from '../atoms';
import { IMensaje,IGuia } from '../../interface';
import { connect } from 'react-redux';
import { fechaOrganizada , fechaOrganizadaAlert} from '../../functions/index';

interface ChatVentanaProp extends WithStyles<typeof ChatVentanaStyles> {
  guia:IGuia;
  mensajes:IMensaje[];
  open:boolean;
  handleClick: ()=>void;
  children?: React.ReactNode;
  className?: string;
}
const ChatVentanaComponent = (props:ChatVentanaProp) => {
    let ultimaFecha:string = '';
    const classes = props.classes
    const mensajes = props?.mensajes?.map(m => {
      m.Nombre=m.Nombre ? m.Nombre : props.guia.nombre_destinatario
      return m
    });

    //delete(props.guia.nombre_asesor);
    if (mensajes.length) {  
      if (mensajes[mensajes.length-1].Timestamp){
        const ultimoMensaje = fechaOrganizadaAlert(mensajes[mensajes.length-1].Timestamp as string);
        ultimaFecha = `${ultimoMensaje}`;
      }  
    }

    let primeraHora:string='';
        if(mensajes.length){
            if (props.guia.fecha_inicio){
                const ultimoHora = fechaOrganizadaAlert(props.guia.fecha_inicio.toDate().toString());
                primeraHora = `${ultimoHora}`
        }
    }

    const classBox = !props.open ? classes['aumentada'] : classes['disminuida'];
    useEffect(() => {
      const element = document.getElementById("gridScroll");
      if(element) element.scrollTop = element.scrollHeight
    })
    return (
        <Box marginLeft="2%" className={classBox}>
              <Box display="flex" justifyContent="space-between">
                 <Box marginTop="3%" marginBottom="2%" width="100%">
                  <Box fontSize="20px" display="inline" marginRight="2%">
                   Guía: {props.guia.guia}
                  </Box>
                  <Box fontSize="10px" display="inline">
                    Ultimo mensaje: {ultimaFecha}
                  </Box>
                  <Box display="inline" className={classes['input-container']}>
                    {/* <Input id="input-search" disableUnderline={true} className={classes['input-busqueda']} endAdornment={
                    <InputAdornment position="end">
                      <IconButton onClick={() => handleClickSearch()}
                        aria-label="buscar"
                      >
                        <Search/>
                      </IconButton>
                    </InputAdornment>
                  }></Input> */}
                  </Box>
                 </Box>
                <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    edge="end"
                    onClick={props.handleClick}
                    className={props.open ? classes.hide : ""}>
                    <Menu/>
                </IconButton>
              </Box>
            <Card className={classes.root} variant="outlined">
                <CardHeader className={classes.header} title={<TitleHeader title={props.guia.nombre_destinatario}/>}></CardHeader>
                <CardContent className={classes.padding}>
                    <Box>
                      <Grid container spacing={1} direction="column" justify="flex-start">
                          <Grid container item xs={12} direction="column" justify="flex-start">
                              <Box m={1} >
                              <Typography align="center">
                                        <Box fontSize={15}>Chat iniciado {primeraHora}</Box>
                              </Typography>

                              </Box>                  
                          </Grid>
                          {/* <Grid  item xs={12}>
                              <Alerta tipo={1}/> 
                          </Grid>  */}
                      </Grid>    
                      
                      <Grid id="gridScroll" container spacing={1} justify="flex-start" className={classes.scrolleable}>
                        {
                          
                          mensajes.length ? mensajes.map((m:IMensaje) => {
                            return (
                              <div>
                              {
                              <Grid item xs={12}>
                                <Mensaje guia={props.guia} mensaje={m} />
                              </Grid>
                              }

                              </div>
                            )
                          }
                          ) : ""
                        }
                        
                      </Grid>    
                    </Box>
                    
                </CardContent>
                    
                <CardContent className={classes.footer}>  
                    <Grid container spacing={0} direction="column" justify="flex-end"  alignItems="stretch">
                       <Box padding={'10px 0px 0px 0px'}>         
                        <EnviarMensaje guia={props.guia} mobile={false}/>
                        </Box>   
                    </Grid>  
                </CardContent>
            </Card>
        </Box>
    );
}

const TitleHeader = (props:any) =>{
  return(
  <Box fontSize="15px" >Destinatario: {props.title} </Box>
  );

}


const mapStateToProps = (state:any) => {
  return {
    mensajes: state.mensajesReducer,
    guia: state.guiasReducer
  }
}

const mapDispatchToProps = () => ({})


export const ChatVentana = withStyles(ChatVentanaStyles)(connect(mapStateToProps,mapDispatchToProps)(ChatVentanaComponent))